// A slow connection must not restart the hero request every slideshow tick.
export function loadHeroImage({ candidates, preview, onDisplay, timeoutMs = 8000 }) {
  let cancelled = false;
  let finished = false;
  let image;
  let timer;
  let previewImage;
  let previewLoaded = false;
  const clearImage = () => {
    clearTimeout(timer);
    if (image) { image.onload = null; image.onerror = null; image.src = ''; }
  };
  if (preview) {
    previewImage = new Image();
    previewImage.fetchPriority = 'high';
    previewImage.onload = () => {
      previewLoaded = true;
      if (!cancelled && !finished) onDisplay(preview, false, previewImage);
    };
    previewImage.src = preview;
  }
  const load = index => {
    if (cancelled) return;
    clearImage();
    if (index >= candidates.length) {
      finished = true;
      if (previewLoaded) onDisplay(preview, true, previewImage);
      return;
    }
    const src = candidates[index];
    const current = new Image();
    image = current;
    current.decoding = 'async';
    current.fetchPriority = 'high';
    current.onload = () => {
      if (cancelled || image !== current) return;
      clearTimeout(timer);
      finished = true;
      onDisplay(src, true, current);
    };
    current.onerror = () => load(index + 1);
    timer = setTimeout(() => load(index + 1), timeoutMs);
    current.src = src;
  };
  load(0);
  return () => {
    cancelled = true;
    clearImage();
    if (previewImage) { previewImage.onload = null; previewImage.src = ''; }
  };
}
